import React from "react";
import { motion } from "framer-motion";
import proc1 from "../assets/Digital tools-amico (1).png";
import proc2 from "../assets/Digital tools-bro.png";
import proc3 from "../assets/Digital tools-rafiki (1).png";
import proc4 from "../assets/Charts-amico.png";





const scrollReveal = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.2 },
  transition: { duration: 0.6, ease: "easeOut" },
};

const staggerContainer = {
  initial: {},
  whileInView: {
    transition: {
      staggerChildren: 0.1,
    },
  },
};

const cardItem = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.5, ease: "easeOut" },
};

function Process() {
  const PROCESS_STEPS = [
    {
      title: "Research & Discovery",
      desc: "We analyze your business, target audience, and competitors to understand the best opportunities for growth.",
      img: proc1
    },
    {
      title: "Strategy Development",
      desc: "A customized marketing strategy is created based on your goals and market positioning.",
      img: proc2
    },
    {
      title: "Campaign Execution",
      desc: "Our team implements marketing campaigns across the most effective digital channels.",
      img: proc3
    },
    {
      title: "Optimization & Growth",
      desc: "Campaign performance is monitored and optimized continuously to improve results and scale growth.",
      img: proc4
    }
  ];

  return (
    <section id="process" className="process">
      <motion.div 
        className="process-header"
        {...scrollReveal}
      >
        <p className="process-sub">— Our Process —</p>
        <h2>Our Growth Marketing Process</h2>
      </motion.div>

      <motion.div 
        className="process-container"
        variants={staggerContainer}
        initial="initial"
        whileInView="whileInView"
        viewport={{ once: true, amount: 0.1 }}
      >
        {PROCESS_STEPS.map((step, index) => (
          <motion.div 
            key={index} 
            className="process-card"
            variants={cardItem}
          >
            <h3>{step.title}</h3>
            <p>{step.desc}</p>
            <img src={step.img} alt={step.title} className="icon" />
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
}

export default Process;